import { apiClient } from "services/api-client";

/**
 * Frameworks API Service
 * Manages regulatory and security frameworks (LGPD, GDPR, ISO 27001, etc.)
 */

/**
 * Get all available frameworks
 */
export const getFrameworks = async () => {
  return await apiClient.get('/frameworks');
};

/**
 * Get frameworks in use by a specific company
 */
export const getFrameworksInUse = async (companyId) => {
  return await apiClient.get(`/frameworks/in-use?companyId=${companyId}`);
};
